export class OrganizationDomainSsoDetailsRequest {
  constructor(public email: string) {}
}
